import type { InvitationInfo } from "../domain/invitation-info";
import type { SelfSignUpInvitation } from "../domain/self-sign-up-invitation";
import type { ResetPasswordPayload } from "./payload/reset-password.payload";
import type { SignUpPayload } from "./payload/sign-up.payload";

export abstract class OnboardingProvider {
  abstract getInvitationInfo(token: string): Promise<InvitationInfo>;
  abstract requestValidationEmailCode(email: string): Promise<{ success: boolean }>;

  abstract getSelfSignUpInvitation(token: string): Promise<SelfSignUpInvitation>;
  abstract requestSelfSignUpCode(token: string): Promise<void>;

  abstract requestEmailVerification(email: string): Promise<void>;
  abstract confirmEmailVerification(payload: { email: string; code: string }): Promise<{ activationToken: string }>;
  abstract signUp(payload: SignUpPayload): Promise<void>;

  abstract validateResetPasswordToken(token: string): Promise<{ email: string }>;
  abstract requestPasswordReset(email: string): Promise<void>;
  abstract resetPassword(payload: ResetPasswordPayload): Promise<void>;
}
